(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Hero clip carousel with peeking neighbours
  document.querySelectorAll('[data-fv-hero]').forEach(function (root) {
    var viewport = root.querySelector('.fv-hero__viewport');
    var track = root.querySelector('.fv-hero__track');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.fv-hero__slide'));
    var dots = root.querySelectorAll('[data-dot]');
    if (!slides.length) return;
    var index = 0;
    var timer = null;
    function place() {
      var slide = slides[index];
      var offset = slide.offsetLeft - (viewport.clientWidth - slide.clientWidth) / 2;
      track.style.transform = 'translateX(' + (-offset) + 'px)';
    }
    function show(next) {
      slides[index].classList.remove('is-active');
      if (dots[index]) dots[index].classList.remove('is-active');
      index = (next + slides.length) % slides.length;
      slides[index].classList.add('is-active');
      if (dots[index]) dots[index].classList.add('is-active');
      slides.forEach(function (s, i) {
        var v = s.querySelector('video');
        if (!v) return;
        if (i === index && !reduce) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else v.pause();
      });
      place();
    }
    function restart() {
      if (timer) window.clearInterval(timer);
      if (!reduce && slides.length > 1) timer = window.setInterval(function () { show(index + 1); }, 6500);
    }
    root.querySelector('[data-prev]') && root.querySelector('[data-prev]').addEventListener('click', function () { show(index - 1); restart(); });
    root.querySelector('[data-next]') && root.querySelector('[data-next]').addEventListener('click', function () { show(index + 1); restart(); });
    dots.forEach(function (d) { d.addEventListener('click', function () { show(Number(d.getAttribute('data-dot'))); restart(); }); });
    slides.forEach(function (s, i) { s.addEventListener('click', function (e) { if (i !== index && !e.target.closest('a')) { show(i); restart(); } }); });
    var startX = null;
    viewport.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    viewport.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) { show(index + (dx < 0 ? 1 : -1)); restart(); }
      startX = null;
    });
    window.addEventListener('resize', place);
    show(0);
    restart();
  });

  // Play inline loops only while visible
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting && !reduce) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else v.pause();
      });
    }, { threshold: 0.25 });
    document.querySelectorAll('[data-fv-loop] video').forEach(function (v) { io.observe(v); });
  }

  // Review card slider
  document.querySelectorAll('[data-fv-cards]').forEach(function (root) {
    var track = root.querySelector('.fv-cards__track');
    var step = function () { return Math.max(260, track.clientWidth * 0.8); };
    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  });

  // Top bar arrows
  var bar = document.querySelector('[data-announce]');
  if (bar) {
    var msgs = bar.querySelectorAll('[data-announce-slide]');
    function step(dir) {
      var cur = 0;
      msgs.forEach(function (m, i) { if (m.classList.contains('is-active')) cur = i; m.classList.remove('is-active'); });
      msgs[(cur + dir + msgs.length) % msgs.length].classList.add('is-active');
    }
    var p = bar.querySelector('[data-announce-prev]');
    var n = bar.querySelector('[data-announce-next]');
    if (p) p.addEventListener('click', function () { step(-1); });
    if (n) n.addEventListener('click', function () { step(1); });
  }

  // 10% off side tab
  var tab = document.querySelector('[data-fv-tab]');
  if (tab) {
    var hidden = false;
    try { hidden = sessionStorage.getItem('fv-tab-hidden') === '1'; } catch (e) {}
    if (hidden) tab.hidden = true;
    var panel = document.querySelector('[data-fv-tab-panel]');
    tab.querySelector('[data-fv-tab-open]').addEventListener('click', function () { if (panel) panel.hidden = !panel.hidden; });
    tab.querySelector('[data-fv-tab-close]').addEventListener('click', function () {
      tab.hidden = true;
      if (panel) panel.hidden = true;
      try { sessionStorage.setItem('fv-tab-hidden', '1'); } catch (e) {}
    });
  }
})();
